import React, {Component} from 'react';
import { connect } from 'react-redux';
import HelpPage from './HelpPage';
import FindPeopleForm from '../Search/FindPeopleForm';
import SearchSpotForm from '../Search/SearchSpotForm';
import Checkout from '../checkout';

class Pages extends Component {

  render() {
    const {isNavHelpOpened, isSearchFormOpened, isFindPeopleFormOpened, isCheckoutPageOpened} = this.props;
    const displayProperty = (isNavHelpOpened || isSearchFormOpened || isFindPeopleFormOpened || isCheckoutPageOpened) ? "block" : "none";

    return (
      <div style={{display: displayProperty}}>
        {isSearchFormOpened && <SearchSpotForm />}
        {isFindPeopleFormOpened && <FindPeopleForm />}
        {isNavHelpOpened && <HelpPage />}
        {isCheckoutPageOpened && <Checkout />}
      </div>
    );
  }

}

const mapStateToProps = (state) => (
  {
    isNavHelpOpened: state.navOptions.isNavHelpOpened,
    isSearchFormOpened: state.navOptions.isSearchFormOpened,
    isFindPeopleFormOpened: state.navOptions.isFindPeopleFormOpened,
    isCheckoutPageOpened: state.navOptions.isCheckoutPageOpened
  }
);

export default connect(mapStateToProps)(Pages);



// WEBPACK FOOTER //
// ./src/containers/NavOptions/Pages.js